export const ACTIVE_SPEAKER = 'active_speaker'
export const ACTIVE_SPEAKER_DATA = 'active_speaker_data'
